export default __webpack_public_path__ + "static/customer-experience-mobile-banner-72d135a9d901fcb03830282e3211e17e.png";